import { MiniMap, useReactFlow, XYPosition } from '@xyflow/react';
import { useRef } from 'react';

const NavigatingMiniMap = () => {
  const { getViewport, setViewport } = useReactFlow();
  const lastClickRef = useRef(0);

  const handleMiniMapClick = (_: React.MouseEvent, position: XYPosition) => {
    const now = Date.now();
    const doubleClick = now - lastClickRef.current < 300; // 250ms threshold
    lastClickRef.current = now;

    const { zoom } = getViewport();

    // Center the viewport on the clicked position
    const next = {
      x: -(position.x * zoom) + window.innerWidth / 2,
      y: -(position.y * zoom) + window.innerHeight / 2,
      zoom,
    };
    setViewport(next, { duration: 200 });

    // On double click, zoom in (or zoom out if preferred)
    if (doubleClick) {
      setViewport(
        {
          ...next,
          zoom: zoom * 1.1,
        },
        { duration: 200 }
      );
    }
  };

  return (
    <MiniMap
      pannable
      zoomable
      onClick={handleMiniMapClick}
      style={{
        position: 'absolute',
        right: 12,
        bottom: 12,
        width: 180,
        height: 120,
      }}
    />
  );
};

export default NavigatingMiniMap;
